import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  summary: null,
  pendingApproval: [],
  delayedOrders: [],
  summaryLoading: false,
  tablesLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchSummaryStart(state) {
      state.summaryLoading = true;
      state.error = null;
    },
    fetchSummarySuccess(state, action) {
      state.summaryLoading = false;
      state.summary = action.payload;
    },
    fetchSummaryFailure(state, action) {
      state.summaryLoading = false;
      state.error = action.payload;
    },

    fetchTablesStart(state) {
      state.tablesLoading = true;
      state.error = null;
    },
    fetchTablesSuccess(state, action) {
      state.tablesLoading = false;
      state.pendingApproval = action.payload.pendingApproval;
      state.delayedOrders = action.payload.delayedOrders;
    },
    fetchTablesFailure(state, action) {
      state.tablesLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSummaryStart,
  fetchSummarySuccess,
  fetchSummaryFailure,
  fetchTablesStart,
  fetchTablesSuccess,
  fetchTablesFailure,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;